import moment from "moment";

import { BetStateEnum, BetStateViewEnum } from "@app/dev/constants/enums/betState";
import { TicketTypes } from "@tickets/constants";

const activeStates = new Set([BetStateEnum.Won, BetStateEnum.CashedOut, BetStateEnum.Returned]);

// const checkCasinoAccepted = (dataFromSwarm, dataFromCasino) => {
//   if (!dataFromSwarm || !dataFromCasino) return false;

//   const pendingTime = moment(dataFromSwarm.Created).add(10, "m").toDate();

//   return new Date() < pendingTime && !dataFromSwarm.WinAmount;
// };

export const getTicketState = ({ bet_state_id, dataFromCasino, dataFromSwarm }) => {
  // if (checkCasinoAccepted(dataFromSwarm, dataFromCasino)) {
  //   return BetStateEnum.Accepted;
  // } // 10 minute check
  if (dataFromCasino && !dataFromCasino.Settled && !dataFromCasino.IsRollbacked && !dataFromSwarm?.WinAmount) {
    return BetStateEnum.Accepted;
  }

  if (bet_state_id === BetStateEnum.Rejected) {
    return BetStateEnum.Rejected;
  }

  if (bet_state_id === BetStateEnum.NotResulted) {
    return BetStateEnum.NotResulted;
  }

  if (bet_state_id === BetStateEnum.CashedOut) {
    return BetStateEnum.CashedOut;
  }

  if (bet_state_id === BetStateEnum.Returned || dataFromCasino?.IsRollbacked) {
    return BetStateEnum.Returned;
  }

  if (bet_state_id === BetStateEnum.Lost || ((dataFromSwarm && Object.keys(dataFromSwarm).length !== 0) && !dataFromSwarm.WinAmount && dataFromCasino?.Settled)) {
    return BetStateEnum.Lost;
  }

  if (bet_state_id === BetStateEnum.Won || (dataFromSwarm?.WinAmount > 0 && !dataFromCasino?.IsRollbacked)) {
    return BetStateEnum.Won;
  }

  if (dataFromSwarm?.WinAmount && dataFromSwarm.WinAmount === dataFromSwarm.Amount) {
    return BetStateEnum.Rollbacked;
  } //TODO review after backend/casino Rollbacked state right implementation

  return BetStateEnum.Accepted;
};

export const getTicketStateName = (item) => {
  if (!item) return null;

  const { dataFromSwarm, dataFromCasino, ticketType } = item;

  const ticketState = getTicketState({
    bet_state_id: dataFromSwarm?.state_id,
    dataFromSwarm,
    dataFromCasino,
  });

  const isPayable = activeStates.has(ticketState);
  let stateEnum = BetStateViewEnum[ticketState];

  if (
    ticketType === TicketTypes.CASINO &&
    dataFromSwarm?.WinAmount &&
    dataFromSwarm?.WinAmount === dataFromSwarm?.Amount
  )
    stateEnum = BetStateViewEnum[BetStateEnum.Returned];
  else if (ticketType === TicketTypes.DEPOSIT) stateEnum = "DEPOSIT";

  return {
    isPayable,
    stateEnum,
    ticketState,
  };
};
